export const version = '1.15.5';
//# sourceMappingURL=version.js.map